import CIMSFormItem from 'components/CIMSFormItem'
import { IssueResolutionTextAreaOptions } from './utils'
import { HelpMessage } from 'utils/constants'
import { CIMSFormItemProps } from 'components/CIMSFormItem/types'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import CIMSTextArea from 'components/CIMSTextArea'

const IssueFormItem: React.FC<Pick<CIMSFormItemProps, 'disabled'>> = ({
  disabled,
}) => {
  const [options, { some }] = useDisabledOptions(disabled)
  return (
    <CIMSFormItem
      name="issue"
      label="Issue"
      requiredMessage="Please enter an issue"
      disabled={options}
      help={HelpMessage.FieldDesignChanges.FDCTracker.Issue}
    >
      <CIMSTextArea disabled={some} {...IssueResolutionTextAreaOptions} />
    </CIMSFormItem>
  )
}

export default IssueFormItem
